import Cookies from 'js-cookie'

const state = {
  sidebar: {
    opened: Cookies.get('sidebarStatus') ? !!+Cookies.get('sidebarStatus') : true,
    withoutAnimation: false
  },
  device: 'desktop',
  size: Cookies.get('size') || 'medium',
  withdrawalState: {
    1: "未审核",
    2: "拒绝",
    3: "已转账",
  },
  commissionState: {
    1: "未入账",
    2: "取消",
    3: "已入账",
  },
  orderState: {
    1: "未支付",
    2: "已支付",
    3: "退款",
  },
  chargeOrderState: {
    1: "未支付",
    2: "已支付",
    3: "退款",
    4: "取消",
    5: "已充值",
  },
  wifiOrderState: {
    0: "未授权",
    1: "已授权",
    2: "已解冻",
  },
  wifiOrderWay: {
    1: '厂家邮寄',
    2: '门店现货'
  },
  deliveryState: {
    0: "待发货",
    1: "运输中",
    2: "已到货",
    3: "已签收",
    4: "已取消"
  },
  finishType: {
    0: "进行中",
    1: "协议期满",
    2: "未激活/套餐过期",
    3: "主动退款",
  },
  onlineType: {
    'wechatpay': "微信付",
    'alipay': "支付宝",
    'huipay': "慧收钱",
    'tradepay': "交易付",
  },
}

const mutations = {
  TOGGLE_SIDEBAR: state => {
    state.sidebar.opened = !state.sidebar.opened
    state.sidebar.withoutAnimation = false
    if (state.sidebar.opened) {
      Cookies.set('sidebarStatus', 1)
    } else {
      Cookies.set('sidebarStatus', 0)
    }
  },
  CLOSE_SIDEBAR: (state, withoutAnimation) => {
    Cookies.set('sidebarStatus', 0)
    state.sidebar.opened = false
    state.sidebar.withoutAnimation = withoutAnimation
  },
  TOGGLE_DEVICE: (state, device) => {
    state.device = device
  },
  SET_SIZE: (state, size) => {
    state.size = size
    Cookies.set('size', size)
  }
}

const actions = {
  toggleSideBar({
    commit
  }) {
    commit('TOGGLE_SIDEBAR')
  },
  closeSideBar({
    commit
  }, {
    withoutAnimation
  }) {
    commit('CLOSE_SIDEBAR', withoutAnimation)
  },
  toggleDevice({
    commit
  }, device) {
    commit('TOGGLE_DEVICE', device)
  },
  setSize({
    commit
  }, size) {
    commit('SET_SIZE', size)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/app.js